import { AxiosError } from "axios";

export class CredifyError extends Error {
  status: number = 0;
  method: string = "";
  url: string = "";
  traceId: string = "";
  constructor(apiError: AxiosError) {
    super();
    const prefix = "credify_server_error";
    if (apiError.response && apiError.response.data) {
      // console.log(apiError.response.data);
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      const errors = apiError.response.data["errors"] || [];
      if (errors.length === 0) {
        this.name = `${prefix}:${apiError.response.status}`;
        this.message = apiError.response.statusText || "unknown";
      } else {
        const e = errors[0];
        this.name = `${prefix}:${e.code}`;
        this.message = e.localized_message?.text || e.message;
      }
      this.status = apiError.response.status;
      this.traceId = apiError.response.headers?.tracer || "";
      this.method = apiError.response.config.method || "";
      this.url = apiError.response.config.url || "";
      // console.log(apiError.response.headers);
    } else if (apiError.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      this.name = `${prefix}:request_error`;
      this.message =
        "The request has failed. Server is not reachable or you are not connected with network.";
      this.status = 0;
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log("Error", apiError.message);
      this.name = `${prefix}:unknown_error`;
      this.message =
        "The request has failed. Server is not reachable or you are not connected with network.";
      this.status = 0;
    }
  }
}

export class OIDCError extends Error {
  private status: number = 0;
  constructor(apiError: AxiosError) {
    super();
    const prefix = "oidc_server_error";
    if (apiError.response && apiError.response.data) {
      /*
       * The request was made and the server responded with a
       * status code that falls out of the range of 2xx
       */
      const name = apiError.response.data["error"] || "unknown";
      this.name = `${prefix}:${name}`;
      this.message = apiError.response.data["error_description"] || "unknown";
      this.status = apiError.response.status;
      const oidcErrorHint = apiError.response.data["error_hint"] || "unknown";
      console.error({ oidcErrorHint });
      // console.log(apiError.response.headers);
    } else if (apiError.request) {
      /*
       * The request was made but no response was received, `error.request`
       * is an instance of XMLHttpRequest in the browser and an instance
       * of http.ClientRequest in Node.js
       */
      console.log(apiError.request);
      this.name = `${prefix}:request_error`;
      this.message =
        "The request has failed. Server is not reachable or you are not connected with network.";
      this.status = 0;
    } else {
      // Something happened in setting up the request and triggered an Error
      console.log("Error", apiError.message);
      this.name = `${prefix}:unknown_error`;
      this.message =
        "The request has failed. Server is not reachable or you are not connected with network.";
      this.status = 0;
    }
  }
}
